import { render, staticRenderFns } from "./GerenciaMain.vue?vue&type=template&id=534bc326&"
import script from "./GerenciaMain.vue?vue&type=script&lang=js&"
export * from "./GerenciaMain.vue?vue&type=script&lang=js&"
import style0 from "./GerenciaMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports